/**
 * Verify that the file being uploaded is not larger than the maximum.
 * @param e
 */
export function checkFileSize(e) {
  const input = document.getElementById('artifact') as HTMLInputElement;
  const maxFileSize = input.getAttribute('data-upload-max-filesize');
  const maxFileSizeInBytes = +input.getAttribute('data-upload-max-filesize-in-bytes');
  const file = input && input.files ? input.files[0] : null;
  if (file && (file.size > maxFileSizeInBytes)) {
    e.preventDefault();
    alert(`The file is too large. It must be less than ${maxFileSize}B.`);
  }
}
